<template>
  <div class="merchant">
    <v-toolbar
      color="white"
      fixed
      app
      flat
      tabs
      :class="salePageIsActive && showSearch ? 'dis-toolbat-content' : ''"
      :style="salePageIsActive && showSearch ? 'position: inherit;' : ''"
    >
      <template v-if="!showSearch">
        <v-toolbar-title v-if="merchant != null">
          <v-avatar size="36px" class="mr-2">
            <img v-if="merchant.pagelogo" :src="merchant.pagelogo" alt />
          </v-avatar>
          {{
            salePageIsActive && !$route.query.userid
              ? salePageShopName
              : merchant.pagename
          }}
        </v-toolbar-title>

        <v-spacer></v-spacer>

        <v-menu data-app offset-y attach>
          <template v-slot:activator="{ on }">
            <v-toolbar-title v-on="on">
              <v-layout>
                <v-flex>
                  <flag :iso="$i18n.locale() == 'en' ? 'gb' : $i18n.locale()" />
                  &nbsp;
                  {{ $i18n.locale() ? $i18n.locale().toUpperCase() : '' }}
                </v-flex>
                <v-flex>
                  <v-icon>mdi-chevron-down</v-icon>
                </v-flex>
              </v-layout>
            </v-toolbar-title>
          </template>

          <v-list>
            <v-list-tile
              v-for="(item, lindex) in langOption"
              :key="'lang_' + lindex"
              @click="onChangeLang(item.value)"
            >
              <v-list-tile-title>
                <flag :iso="item.flag" />
                &nbsp; {{ item.value.toUpperCase() }}
              </v-list-tile-title>
            </v-list-tile>
          </v-list>
        </v-menu>
      </template>

      <slot name="search"></slot>

      <template v-slot:extension>
        <slot name="category"></slot>
        <slot name="header"></slot>
      </template>
    </v-toolbar>

    <div class="container" v-if="false">
      <div class="row" v-if="merchant != null">
        <div class="col-xs-8 col-sm-10">
          <div
            class="profile"
            style="
              margin: auto;
              display: inline-block;
              margin-right: 5px;
              vertical-align: middle;
            "
          >
            <a :href="'https://m.me/' + merchant.pageid">
              <img
                :src="merchant.pagelogo"
                :alt="merchant.pagename"
                class="img-responsive"
                style="width: 25px; height: 25px"
              />
            </a>
          </div>
          <div
            style="
              display: inline-block;
              vertical-align: middle;
              width: calc(100% - 33px);
              overflow: hidden;
              white-space: nowrap;
              text-overflow: ellipsis;
            "
          >
            <a :href="'https://m.me/' + merchant.pageid" style>
              {{ merchant.pagename }}
            </a>
          </div>
        </div>
        <div class="col-xs-4 col-sm-2 text-right">
          <div class="dropdown" :class="{ open: showLang }">
            <button
              id="dLabel"
              type="button"
              class="btn"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
              @click="showLang = !showLang"
            >
              <flag :iso="$i18n.locale() == 'en' ? 'gb' : $i18n.locale()" />
              &nbsp;
              {{ $i18n.locale() ? $i18n.locale().toUpperCase() : '' }}
              <span class="caret"></span>
            </button>
            <ul
              class="dropdown-menu dropdown-menu-right"
              aria-labelledby="dLabel"
              style="min-width: 80px"
            >
              <li>
                <a href="javascript:void(0);" @click="onChangeLang('en')">
                  <flag iso="gb" />&nbsp;EN
                </a>
              </li>
              <li>
                <a href="javascript:void(0);" @click="onChangeLang('th')">
                  <flag iso="th" />&nbsp;TH
                </a>
              </li>
              <li>
                <a href="javascript:void(0);" @click="onChangeLang('la')">
                  <flag iso="la" />&nbsp;LA
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div
        class="text-center"
        style="padding-top: 25px; padding-bottom: 25px"
        v-else
      >
        <sync-loader
          :key="theme.color"
          :color="theme.color"
          :size="'10px'"
        ></sync-loader>
      </div>

      <slot></slot>
    </div>
  </div>
</template>

<script>
import MerchatDetailMixin from './MerchatDetailMixin.js'
export default {
  mixins: [MerchatDetailMixin],
  name: 'DefaultMerchantDetail'
}
</script>

<style lang="scss" scoped></style>
